/* eslint-disable import/prefer-default-export */
const filterSearchNames = [
  "category",
  "filter",
  "vendor",
  "price",
  "parts",
  "withinval",
  "page",
  "manufacturer",
  "model",
];

const searchPartIsForFilters = (
  searchPart: string,
  extraSearchNames?: string[]
) => {
  const allSearchNames = filterSearchNames.concat(extraSearchNames || []);

  return allSearchNames.some((filterName) =>
    searchPart.startsWith(`${filterName}=`)
  );
};

export const getNoFiltersUrl = (
  currentUrl: string,
  extraSearchVarsToRemove?: string[]
) => {
  const searchIndex = currentUrl.indexOf("?");

  if (searchIndex < 0) return currentUrl;

  const searchParts = currentUrl
    .substring(searchIndex)
    .replace("?", "")
    .split("&");

  const newSearchParts = searchParts.filter(
    (searchPart) =>
      searchPart.length &&
      !searchPartIsForFilters(searchPart, extraSearchVarsToRemove)
  );

  const urlPath = searchIndex === 0 ? "" : currentUrl.substring(0, searchIndex);

  const newSearch =
    newSearchParts.length === 0 ? "" : `?${newSearchParts.join("&")}`;

  return urlPath + newSearch;
};

export const shouldNoFollow = (url: string): boolean => {
  return !!(url && url.toLowerCase().includes("multi=true"));
};

export const addParamToUrl = (
  currentUrl: string,
  paramName: string,
  paramValue: string
): string => {
  const searchIndex = currentUrl.indexOf("?");

  let searchParams = new URLSearchParams("");

  if (searchIndex > 0) {
    const queryString = currentUrl.substring(searchIndex + 1);
    searchParams = new URLSearchParams(queryString);
  }

  if (searchParams.get(paramName)) {
    searchParams.delete(paramName);
  }

  if (searchParams.get("page")) {
    searchParams.delete("page");
  }

  const multiParamValue = searchParams.get("multi");

  if (multiParamValue) {
    searchParams.delete("multi");
  }

  searchParams.append(paramName, paramValue);

  if (multiParamValue) {
    searchParams.append("multi", multiParamValue);
  }

  const urlPath =
    searchIndex === -1 ? currentUrl : currentUrl.substring(0, searchIndex);

  return `${urlPath}?${decodeURIComponent(searchParams.toString())
    // URLSearchParams replaces spaces with pluses, we want spaces to be "%20"
    .replace(/\+/g, "%20")}`;
};

export const getParamValueFromUrl = (
  url: string,
  paramName: string
): string => {
  const searchIndex = url.indexOf("?");

  if (searchIndex > 0) {
    const queryString = url.substring(searchIndex + 1);
    const searchParams = new URLSearchParams(queryString);
    return searchParams.get(paramName) || "";
  }

  return "";
};

export const removeParamFromUrl = (url: string, paramName: string): string => {
  const searchIndex = url.indexOf("?");
  let searchParams = new URLSearchParams("");

  if (searchIndex > 0) {
    const queryString = url.substring(searchIndex + 1);
    searchParams = new URLSearchParams(queryString);

    searchParams.delete(paramName);
  }

  const urlPath = searchIndex === -1 ? url : url.substring(0, searchIndex);

  return searchParams.toString().length > 0
    ? `${urlPath}?${decodeURIComponent(searchParams.toString())}`
    : urlPath;
};

export const getAllParamValueFromUrl = (
  url: string,
  paramName: string
): string[] => {
  const searchIndex = url.indexOf("?");

  if (searchIndex > 0) {
    const queryString = url.substring(searchIndex + 1);
    const searchParams = new URLSearchParams(queryString);
    return searchParams.getAll(paramName) || "";
  }

  return [];
};
